
























import {Component, Vue, Prop} from 'vue-property-decorator'
import FlashMessage from '@/components/common/FlashMessage.vue'
import {Getter, Mutation, Action} from 'vuex-class'

@Component({
    components: {
        FlashMessage,
    },
})
export default class AppHeader extends Vue {
  @Prop({type: String, default: 'border-bottom-light'}) public borderClass!: string
  @Prop({type: String, default: ''}) public titleClass!: string
  @Getter('flash') public flash!: boolean

  public reload() {
        window.location.href = '/'
  }
}
